import React from "react";
import { Slide, Modal } from "@mui/material";

export const SlideModal = ({
  children,
  open,
  onClose,
  direction = "down",
  className,
}) => (
  <Modal
    className={className}
    open={open}
    onClose={onClose}
    closeAfterTransition
    slotProps={{
      backdrop:
        className === "irq-modal-mobile"
          ? {
              style: {
                background: "linear-gradient(-45deg, #182539 40%, #6b001e 80%)",
              },
            }
          : {},
    }}
  >
    <Slide direction={direction} in={open} mountOnEnter unmountOnExit>
      {children}
    </Slide>
  </Modal>
);
